export const HOST = ['', '', '']; // 项目依然部署在官网同域下
export const API = {
    // TODO: 待迁移 @hujiajie
    sms: '/api/v1/phone' // 发送短信
};
